import { render, staticRenderFns } from "./GlobalSnackBarMobile.vue?vue&type=template&id=286b7d99&scoped=true"
import script from "./GlobalSnackBarMobile.vue?vue&type=script&lang=js"
export * from "./GlobalSnackBarMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b7d99",
  null
  
)

export default component.exports